import { MediaElement, MediaText } from 'editor/src/store/design/types';

/**
 * Type guard to check if an element is a text element
 */
export function isTextElement(element: MediaElement): element is MediaText {
  return element.type === 'text';
}

/**
 * Type guard to check if all elements are text elements
 */
export function areAllTextElements(elements: MediaElement[]): elements is MediaText[] {
  return elements.every(isTextElement);
}
